export default {
  "black": "_black_5wcw1_1"
};import "ni:sha-256;kyHnpkOxYq8OrvIqOk9RyIkEwo8SMyT_4yrLi_anTsk";